<template>
    <article class="actualite article post-card-list">
        <div class="row">
            <div class="col-12 col-md-4 col-lg-3 position-relative card-thumb">
                <div class="position-relative">
                    <img :src=" articleCategoryImage ?? '' " class="img-fluid">
                    <div class="post-card-list_category news"
                         :style="'background:' +  articleCategoryColour "
                         v-html="articleCategory?.title ?? 'SOMETHING WEIRD IS UPON US' "
                    ></div>
                </div>
            </div>
            <div class="col-12 col-md-8 col-lg-9 p-4 card-info">
                <div class="post-card-list_date">{{ article.prettyPublishDate }}</div>
                <h2 class="post-card-list_title">
                    <a
                        :href="article.url"
                        v-html="article.safeTitle + '<span class=\'sr-only\'>Type d\'article : ' + articleCategory?.title + '</span>' " >
                    </a>
                </h2>
                <div class=" post-card-list_excerpt"
                    v-html="article.excerpt ?? 'DO NOT FORGET THE EXCERPT'"></div>
        </div>
        </div>
    </article>
</template>

<script setup>

import { computed } from 'vue';
import { useStore } from "vuex";

let store        = useStore();
// let copydeck = computed( () => store.state.copydeck );
const props      = defineProps( [
    "article",
] );
let foundArticle = computed( () => props.article );

// let categories  = computed( () => store.getters.categories );
let articleCategory       = computed( () => store.getters.categories.find( cat => cat.id === foundArticle.value.id_articles_categories ) );
let articleCategoryImage  = computed( () => articleCategory?.value?.image ?? '' );
let articleCategoryColour = computed( () => articleCategory?.value?.colour ?? '' );


</script>

<style scoped>

</style>
